/**
 * PandaApi — Vue-era API client (converted from js/api.js)
 *
 * Pages import getApi (the factory function), then call `const api = getApi()`.
 */

const DEFAULT_BASE_URL = process.env.VUE_APP_API_BASE || 'https://api.pandacampus.com';

let _singleton = null;

function createApiClient(options) {
  options = options || {};
  const baseUrl = (options.baseUrl || DEFAULT_BASE_URL).replace(/\/+$/, '');
  var win = typeof window !== 'undefined' ? window : globalThis;
  const fetchImpl = options.fetch || (typeof fetch !== 'undefined' ? fetch.bind(win) : null);

  if (!fetchImpl) throw new Error('当前环境不支持 fetch');

  function request(path, requestOptions) {
    requestOptions = requestOptions || {};
    return fetchImpl(baseUrl + path, requestOptions).then(function (response) {
      if (!response.ok) {
        if (response.status === 401) {
          var err = new Error('需要登录后才能查看');
          err.status = 401;
          err.code = 401;
          throw err;
        }
        var httpErr = new Error('请求失败：HTTP ' + response.status);
        httpErr.status = response.status;
        throw httpErr;
      }
      return response.json();
    });
  }

  function login(account, password) {
    return request('/user/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ account, password })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '登录失败');
      }
      return unwrapUserinfo(data.data);
    });
  }

  function register(payload) {
    return request('/user/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '注册失败');
      }
      return unwrapUserinfo(data.data);
    });
  }

  function unwrapUserinfo(payload) {
    payload = payload || {};
    return payload.userinfo || payload;
  }

  function jsonHeaders(token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    return headers;
  }

  function queryString(params) {
    params = params || {};
    var pairs = [];
    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (value === undefined || value === null || value === '') return;
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    });
    return pairs.length ? '?' + pairs.join('&') : '';
  }

  function uploadFile(file) {
    var formData = new FormData();
    formData.append('file', file);
    return request('/common/upload', {
      method: 'POST',
      body: formData
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '上传失败');
      }
      return data.data || {};
    });
  }

  function getUser(id, token) {
    var query = id === undefined || id === null || id === ''
      ? ''
      : '?id=' + encodeURIComponent(id);
    return request('/user/getUser' + query, {
      method: 'POST',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '个人资料加载失败');
      }
      return data.data || {};
    });
  }

  function userInfo(token) {
    return request('/user/info', {
      method: 'POST',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '个人资料加载失败');
      }
      return data.data || {};
    });
  }

  function circleList(params, token) {
    params = params || {};
    return request('/user/circlelist', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify({
        page: params.page || 1,
        limit: params.limit || 20,
        search: params.search || '',
        city: params.city || '',
        contry: params.contry || ''
      })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '圈子列表加载失败');
      }
      return data.data || {};
    });
  }

  function profile(payload, token) {
    return request('/user/profile', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '个人资料保存失败');
      }
      return data.data;
    });
  }

  function changePassword(payload, token) {
    return request('/user/changePassword', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '瀵嗙爜淇敼澶辫触');
      }
      return data;
    });
  }

  function forgotPassword(payload) {
    return request('/user/forgot', {
      method: 'POST',
      headers: jsonHeaders(),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '忘记密码验证失败');
      }
      return data;
    });
  }

  function authentication(payload, token) {
    return request('/user/authentication', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '瀹炲悕璁よ瘉鎻愪氦澶辫触');
      }
      return data;
    });
  }

  function nearList(params, token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    return request('/goods/nearList', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        range: params.range,
        limit: params.limit,
        page: params.page,
        circle_id: params.circle_id != null ? params.circle_id : 0,
        type_id: params.type_id != null ? params.type_id : 0
      })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '圈子商品加载失败');
      }
      return data.data || {};
    });
  }

  function categories(token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    return request('/goods', {
      method: 'POST',
      headers: headers
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '分类加载失败');
      }
      return data.data || [];
    });
  }

  function goodsList(params, token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    return request('/goods/goodsList', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        limit: params.limit || 20,
        page: params.page || 1,
        type_id: params.type_id != null && Number(params.type_id) > 0 ? Number(params.type_id) : '',
        search: params.search || '',
        circle_id: params.circle_id != null && Number(params.circle_id) > 0 ? Number(params.circle_id) : '',
        order: params.order || '',
        sort: params.sort || ''
      })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品列表加载失败');
      }
      return data.data || {};
    });
  }

  function goodsInfo(id, token) {
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers.token = token;
    return request('/goods/goodsInfo', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ id: String(id) })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品详情加载失败');
      }
      return data.data || {};
    });
  }

  function createGoods(payload, token) {
    return request('/goods/createGoods', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品发布失败');
      }
      return data.data;
    });
  }

  function updateGoods(payload, token) {
    return request('/goods/updateGoods', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品编辑失败');
      }
      return data.data;
    });
  }

  function modifyGoods(id, payload, token) {
    return request('/goods/modify' + queryString({ id: id }), {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品编辑失败');
      }
      return data.data;
    });
  }

  function logout(token) {
    return request('/user/logout', {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '退出登录失败');
      }
      return data;
    });
  }

  function likeGoods(id, token) {
    var query = id === undefined || id === null || id === ''
      ? ''
      : '?id=' + encodeURIComponent(id);
    return request('/goods/likeGoods' + query, {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '收藏状态更新失败');
      }
      return data;
    });
  }

  function changeGoodsStatus(id, token) {
    var query = id === undefined || id === null || id === ''
      ? ''
      : '?id=' + encodeURIComponent(id);
    return request('/goods/changeStatus' + query, {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品状态切换失败');
      }
      return data;
    });
  }

  function stopGoodsStatus(id, token) {
    var query = id === undefined || id === null || id === ''
      ? ''
      : '?id=' + encodeURIComponent(id);
    return request('/goods/stopStatus' + query, {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '商品售罄操作失败');
      }
      return data;
    });
  }

  function focusUser(id, token) {
    var query = id === undefined || id === null || id === ''
      ? ''
      : '?id=' + encodeURIComponent(id);
    return request('/user/focus' + query, {
      method: 'POST',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '操作失败');
      }
      return data;
    });
  }

  function myFocus(token) {
    return request('/goods/myfacus', {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '我的关注加载失败');
      }
      return data.data || {};
    });
  }

  function myLike(params, token) {
    params = params || {};
    return request('/goods/mylike', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify({
        limit: params.limit || 22,
        page: params.page || 1
      })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '我的收藏加载失败');
      }
      return data.data || {};
    });
  }

  function myGoods(params, token) {
    params = params || {};
    return request('/goods/myGoods', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify({
        limit: params.limit || 22,
        page: params.page || 1
      })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '我的商品加载失败');
      }
      return data.data || {};
    });
  }

  function wannaList(params, token) {
    params = params || {};
    return request('/wanna' + queryString({
      id: params.id,
      page: params.page || 1
    }), {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '请求失败，请稍后重试');
      }
      return data.data || {};
    });
  }

  function createWanna(payload, token) {
    return request('/wanna/create', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(payload)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '请求失败，请稍后重试');
      }
      return data.data;
    });
  }

  function myWannaList(params, token) {
    params = params || {};
    return request('/wanna/myList' + queryString({
      id: params.id,
      page: params.page || 1
    }), {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '我的求购加载失败');
      }
      return data.data || {};
    });
  }

  function cancelWanna(id, token) {
    if (id === undefined || id === null || id === '') {
      return Promise.reject(new Error('缺少求购id'));
    }
    return request('/wanna/cancel' + queryString({ id: id }), {
      method: 'GET',
      headers: jsonHeaders(token)
    }).then(function (data) {
      if (!data) return {};
      if (data.code !== undefined && data.code !== 1) {
        throw new Error(data.msg || '删除求购失败');
      }
      return data.data !== undefined ? data.data : data;
    });
  }

  function newsList(params, token) {
    params = params || {};
    var body = {
      page: params.page || 1
    };
    if (params.type !== undefined && params.type !== null && params.type !== '') {
      body.type = params.type;
    }
    return request('/news', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify(body)
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '请求失败，请稍后重试');
      }
      return data.data || {};
    });
  }

  function guideList(page) {
    return request('/guide' + queryString({ page: page || 1 }), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '攻略列表加载失败');
      }
      return data.data || {};
    });
  }

  function guideDetail(page, id) {
    return request('/guide/detail', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page: String(page), id: String(id) })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '攻略详情加载失败');
      }
      return data.data || {};
    });
  }

  function getRichText(type) {
    return request('/config' + queryString({ type: type }), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 200) {
        throw new Error((data && data.msg) || '内容加载失败');
      }
      return data.data || '';
    });
  }

  function getBanners() {
    return request('/config' + queryString({ type: 'banners' }), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 200) {
        throw new Error((data && data.msg) || '轮播图加载失败');
      }
      var raw = data.data;
      if (Array.isArray(raw)) return raw;
      if (typeof raw === 'string' && raw.trim()) {
        return raw.split(',').map(function (item) { return item.trim(); }).filter(Boolean);
      }
      return [];
    });
  }

  function getHomeActivity() {
    return request('/config' + queryString({ type: 'home_activity' }), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 200) {
        throw new Error((data && data.msg) || '活动图加载失败');
      }
      var raw = data.data;
      if (Array.isArray(raw)) {
        raw = raw[0];
      }
      if (raw && typeof raw === 'object') {
        raw = raw.url || raw.image || raw.src || '';
      }
      return typeof raw === 'string' ? raw.trim() : '';
    });
  }

  function helpList() {
    return request('/help', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '帮助中心加载失败');
      }
      return data.data || {};
    });
  }

  function helpDetail(id) {
    return request('/help/detail' + queryString({ id: id }), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '帮助详情加载失败');
      }
      return data.data || {};
    });
  }

  function createQuestion(payload, token) {
    return request('/question/create', {
      method: 'POST',
      headers: jsonHeaders(token),
      body: JSON.stringify({ introduction: payload.introduction || '' })
    }).then(function (data) {
      if (!data || data.code !== 1) {
        throw new Error((data && data.msg) || '问题提交失败');
      }
      return data;
    });
  }

  return { login, register, uploadFile, getUser, userInfo, circleList, profile, changePassword, forgotPassword, authentication, nearList, categories, goodsList, goodsInfo, createGoods, updateGoods, modifyGoods, logout, likeGoods, changeGoodsStatus, stopGoodsStatus, focusUser, myFocus, myLike, myGoods, wannaList, createWanna, myWannaList, cancelWanna, newsList, guideList, guideDetail, helpList, helpDetail, createQuestion, getRichText, getBanners, getHomeActivity, request };
}

// ── Singleton access ──
function getApi() {
  if (!_singleton) {
    _singleton = createApiClient({});
  }
  return _singleton;
}

export { createApiClient, getApi };
export default getApi;
